// 存储sessionStorage
/*export const setStore = (name, value,time = 7) => {
    var nameString = name + '=' + encodeURI(value);
	var expiryString = "";
	if(time !== 0) {
	    var expdate = new Date();
	    if(time == null || isNaN(time)) time = 60*60*1000;
	    expdate.setTime(expdate.getTime() +  time);
	    expiryString = ' ;expires = '+ expdate.toGMTString();
	 }
	 var path = " ;path =/";
	 document.cookie = nameString + expiryString + path;
	 console.log(document.cookie)
}

// 获取sessionStorage
export const getStore = key => {
	var cookies=document.cookie;
      cookies+=";";
      var start=cookies.indexOf(key);
      if(start<=-1){ return null; }
      var end=cookies.indexOf(";",start);
      var value=cookies.slice(start+key.length+1,end);
      return unescape(value); 
}

// 删除sessionStorage
export const removeStore = key => {
	var value = CookieUtil.queryCookie(key);
    if(value === null){return false;}
    CookieUtil.addCookie(key,value,{expires:0});
} */

// 存储sessionStorage
export const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.sessionStorage.setItem(name, content);
}

// 获取sessionStorage
export const getStore = name => {
	if (!name) return;
	return window.sessionStorage.getItem(name);
}

// 删除sessionStorage
export const removeStore = name => {
	if (!name) return;
	window.sessionStorage.removeItem(name);
} 

// 获取url参数
export const getQueryString = name => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");  
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;  
}

import { getOpenId,getCodeId } from "@/service/getData"; 
// 是否有openid
export const checkOpenid = async (path = "") => {
	if(isWeixinBrowser()){								// 微信浏览器 或者存在有效的Code
		//alert('检测到是微信浏览器2');
		removeStore('token');
		return await getCodeId(path);
	}else{
		return new Promise(() => {
			setTimeout(() => {
				window.location.href = "https://open.weixin.qq.com/connect/qrconnect?appid=wxa7f384d1495c0f32&redirect_uri=http://www.imedunion.com&response_type=code&scope=snsapi_login&state="+encodeURIComponent(path)+"#wechat_redirect"
			},0)
		}) 
	}
}	

// 获取opend id
export const getWeixinOpenid = async (code = "") => { 
	//alert('进入 getWeixinOpenid方法里面了');
	let res = await getOpenId(code);
	//alert('获取token是否成功:' + res.code);
	if(res.code == -1){ 
		//alert('获取到openid为:' + res.data.openid);					// 获取openid
		setStore('token',res.data.openid)
		setStore('type',res.data.type)
		setStore('nickName',res.data.nickName)
		setStore('headImg',res.data.headImg)
		//alert("token的值设置为：" + res.data.openid);
	}else{
		console.log('获取token失败');
	}
}

//是否微信浏览器
export const isWeixinBrowser = () => {
	return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

// 是否空对象
export const isEmptyObject = (obj) => {
  for (var key in obj) {
    return false;
  }
  return true;
}

// 数据格式是否为空
export const getDataType = (o) =>{
	var isEmpty = false;
	if(typeof o == "object"){
		if(o != null && 'splice' in o && 'join' in o){
			if(o.length == 0){ 
				isEmpty = true; 
			}
		}else{
			if(isEmptyObject(o)){
				isEmpty = true;
			}
		}
	}else{
		if(typeof o == 'string' && o.trim().length==0){
			isEmpty = true; 
		}
	}
	return isEmpty;
}


// WEBPACK FOOTER //
// ./src/config/mUtils.js